<template>
	<div
		class="row h-100 d-flex justify-content-center"
	>
		<div v-if="isCurrentStep(STEPS.EMAIL.name)" class="col-12 col-lg-8">
			<!-- Выбор способа входа -->
			<div class="d-flex flex-column justify-content-center">
				<div class="mb-2 text-secondary">
					Мы отправим вам код для подтверждения вашей личности
				</div>
				<div class="login-tabs mb-4">
					<b-button
						class="login-tabs__button"
						:class="{ current: currentLoginType === 'phone' }"
						@click="setLoginType('phone')"
					>
						Телефон
					</b-button>
					<b-button
						class="login-tabs__button"
						:class="{ current: currentLoginType === 'email' }"
						@click="setLoginType('email')"
					>
						Email
					</b-button>
				</div>
			</div>
			<FormulateForm
				:key="STEPS.EMAIL.name"
				:name="STEPS.EMAIL.name"
				class="row h-100"
				@submit="sendEmailCode"
			>
				<FormulateInput
					v-model="email.value"
					type="text"
					label="Email"
					placeholder="Введите значение"
					class="col-12"
					validation="bail|required|email"
					:validation-messages="{
						'required': 'укажите значение',
						'email': 'введите корректный e-mail',
					}"
				/>
				<div class="col-12 d-flex flex-column justify-content-end align-items-center">
					<span v-if="email.error" class="text-danger mb-2">{{ email.error }}</span>
					<FormulateInput
						type="submit"
						class="submit w-100"
					>
						{{ STEPS.EMAIL.buttonText }}
					</FormulateInput>
				</div>
			</FormulateForm>
		</div>
		<div v-if="isCurrentStep(STEPS.EMAIL_CODE.name)" class="col-12 col-lg-8">
			<div class="row d-flex justify-content-center mb-4">
				<div class="col-12 strong mb-4 text-center">
					{{ email.value }}
				</div>
				<div class="col-10 mb-4 text-center">
					<span>
						Отправили вам на email одноразовый код для входа.
						Проверьте ваш почтовый ящик или
					</span>
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.EMAIL_PASSWORD.name)"
					>
						войдите с помощью пароля
					</b-button>
				</div>
			</div>
			<FormulateForm
				:key="STEPS.EMAIL_CODE.name"
				:name="STEPS.EMAIL_CODE.name"
				class="row justify-content-center"
			>
				<FormulateInput
					v-model="email.code"
					type="text"
					label="Код подтверждения"
					placeholder="Введите значение"
					error-behavior="submit"
					class="col-8"
					inputmode="numeric"
					validation="bail|number|validEmailCode"
					:validation-rules="{
						validEmailCode: () => email.isCodeValid
					}"
					:validation-messages="{
						validEmailCode: 'Неверный код',
						number: 'Код должен состоять из цифр',
					}"
				/>
				<b-button
					variant="primary"
					class="col-8 mb-4"
					:disabled="!email.code"
					@click="submitEmailCode"
				>
					Далее
				</b-button>
				<div class="col-12 d-flex justify-content-center mb-4">
					<div
						v-if="email.timeout"
						class="col-12 text mb-4 text-center text-secondary"
					>
						Отправить повторно можно через {{ formatTime(email.timeout) }}
					</div>
					<b-button
						v-else
						variant="link"
						class="p-0"
						@click="sendEmailCode({ resend: true })"
					>
						Отправить еще раз
					</b-button>
				</div>
				<div class="col-12 d-flex justify-content-center">
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.EMAIL.name)"
					>
						Вернуться назад
					</b-button>
				</div>
			</FormulateForm>
		</div>
		<div v-if="isCurrentStep(STEPS.EMAIL_PASSWORD.name)" class="col-12 col-lg-8">
			<div class="row d-flex justify-content-center mb-4">
				<div class="col-12 strong mb-4 text-center">
					{{ email.value }}
				</div>
				<div class="col-10 mb-4 text-center">
					<span>
						Введите ваш пароль или
					</span>
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.EMAIL_CODE.name)"
					>
						войдите с помощью одноразового кода
					</b-button>
				</div>
			</div>
			<FormulateForm
				:key="STEPS.EMAIL_PASSWORD.name"
				:name="STEPS.EMAIL_PASSWORD.name"
				class="row justify-content-center"
				@submit="loginEmail"
			>
				<FormulateInput
					v-model="email.password"
					type="password"
					label="Пароль"
					placeholder="Введите значение"
					class="col-8"
				/>
				<div class="col-12 col-lg-8 mb-4 d-flex flex-column justify-content-end align-items-center">
					<span v-if="email.error" class="text-danger mb-2">{{ email.error }}</span>
					<FormulateInput
						type="submit"
						class="submit w-100"
					>
						{{ STEPS.EMAIL_PASSWORD.buttonText }}
					</FormulateInput>
				</div>
				<div class="col-12 d-flex justify-content-center">
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.EMAIL.name)"
					>
						Вернуться назад
					</b-button>
				</div>
			</FormulateForm>
		</div>
		<div v-if="isCurrentStep(STEPS.PHONE.name)" class="col-12 col-lg-8">
			<div class="row d-flex justify-content-center mb-4">
				<div class="col-12 strong mb-4 text-center">
					{{ email.value }}
				</div>
				<div class="col-10 mb-4 text-center">
					<span>
						Укажите ваш номер телефона для создания личного кабинета
						- в нем вы сможете видеть статус регистрации и получать информацию по обучению
					</span>
				</div>
			</div>
			<FormulateForm
				:key="STEPS.PHONE.name"
				:name="STEPS.PHONE.name"
				class="row justify-content-center"
				@submit="sendPhoneCode"
			>
				<FormulateInput
					v-model="phone.value"
					type="CustomPhoneInput"
					label="Телефон"
					validation="bail|required|validPhone"
					placeholder="Введите значение"
					class="col-12 col-lg-8"
					:validation-rules="{
						validPhone: () => phone.isPhoneValid
					}"
					:validation-messages="{
						'required': 'укажите телефон',
						validPhone: 'укажите корректный телефон',
					}"
					@validatePhone="(value) => phone.isPhoneValid = value"
				/>
				<div class="col-12 col-lg-8 mb-2 d-flex align-items-end">
					<FormulateInput
						type="submit"
						class="submit w-100"
					>
						{{ STEPS.PHONE.buttonText }}
					</FormulateInput>
				</div>
				<div class="col-12 d-flex flex-column align-items-center justify-content-center">
					<b-button
						variant="link"
						class="p-0 mb-4"
						@click="skipPhoneStep"
					>
						Подтвержу номер позднее
					</b-button>
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.EMAIL.name)"
					>
						Вернуться назад
					</b-button>
				</div>
			</FormulateForm>
		</div>
		<div v-if="isCurrentStep(STEPS.PHONE_CODE.name)" class="col-12 col-lg-8">
			<div class="row d-flex justify-content-center mb-4">
				<div class="col-12 strong mb-4 text-center">
					{{ phone.value }}
				</div>
				<div class="col-10 mb-4 text-center">
					<span>
						Отправили вам код в смс
					</span>
				</div>
			</div>
			<FormulateForm
				:key="STEPS.PHONE_CODE.name"
				:name="STEPS.PHONE_CODE.name"
				class="row justify-content-center"
			>
				<FormulateInput
					v-model="phone.code"
					type="text"
					label="Код подтверждения"
					placeholder="Введите значение"
					error-behavior="submit"
					class="col-8"
					inputmode="numeric"
					validation="bail|number|validPhoneCode"
					:validation-rules="{
						validPhoneCode: () => phone.isCodeValid
					}"
					:validation-messages="{
						validPhoneCode: 'Неверный код',
						number: 'Код должен состоять из цифр',
					}"
				/>
				<b-button
					variant="primary"
					class="col-8 mb-4"
					:disabled="!phone.code"
					@click="submitPhoneCode"
				>
					Далее
				</b-button>
				<div class="col-12 d-flex justify-content-center mb-4">
					<div
						v-if="phone.timeout"
						class="col-12 text mb-4 text-center text-secondary"
					>
						Отправить повторно можно через {{ formatTime(phone.timeout) }}
					</div>
					<b-button
						v-else
						variant="link"
						class="p-0"
						@click="sendPhoneCode({ resend: true })"
					>
						Отправить еще раз
					</b-button>
				</div>
				<div class="col-12 d-flex justify-content-center mb-4">
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.PHONE.name)"
					>
						Изменить номер телефона
					</b-button>
				</div>
				<div class="col-12 d-flex justify-content-center">
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.PHONE.name)"
					>
						Вернуться назад
					</b-button>
				</div>
			</FormulateForm>
		</div>
		<div v-if="isCurrentStep(STEPS.AUTH_PASSWORD.name)" class="col-12 col-lg-8">
			<div class="row d-flex justify-content-center mb-4">
				<div class="col-12 d-flex flex-column strong mb-4">
					<span class="text-center mb-1">{{ email.value }}</span>
					<span class="text-center">{{ phone.value }}</span>
				</div>
				<div class="col-10 mb-4 text-center">
					<span>
						Придумайте пароль к личному кабинету и заполните данные
					</span>
				</div>
			</div>
			<FormulateForm
				:key="STEPS.AUTH_PASSWORD.name"
				:name="STEPS.AUTH_PASSWORD.name"
				class="row justify-content-center"
				@submit="registerUser"
			>
				<FormulateInput
					v-model="last_name"
					type="text"
					label="Фамилия*"
					name="last_name"
					placeholder="Введите значение"
					class="col-8"
					validation="bail|required|cyrillic"
					validation-name="Фамилия"
					:validation-messages="{
						'required': 'укажите фамилию',
						'cyrillic': 'Латинские символы недоступны',
					}"
					:validation-rules="{
						cyrillic: ({ value }) => validateCyrillic(value)
					}"
				/>
				<FormulateInput
					v-model="first_name"
					type="text"
					label="Имя*"
					name="first_name"
					placeholder="Введите значение"
					class="col-8"
					validation="bail|required|cyrillic"
					validation-name="Имя"
					:validation-messages="{
						'required': 'укажите имя',
						'cyrillic': 'Латинские символы недоступны',
					}"
					:validation-rules="{
						cyrillic: ({ value }) => validateCyrillic(value)
					}"
				/>
				<FormulateInput
					v-model="middle_name"
					type="text"
					label="Отчество"
					name="middle_name"
					placeholder="Введите значение"
					class="col-8"
					validation="optional|cyrillic"
					:validation-messages="{
						'cyrillic': 'Латинские символы недоступны',
					}"
					:validation-rules="{
						cyrillic: ({ value }) => validateCyrillic(value)
					}"
				/>
				<FormulateInput
					v-model="password"
					type="password"
					name="password"
					error-behavior="value"
					label="Пароль"
					placeholder="Введите значение"
					validation="required"
					:validation-messages="{
						'required': 'укажите значение',
					}"
					validation-name="Password"
					class="col-8"
				/>
				<FormulateInput
					v-model="passwordConfirm"
					type="password"
					name="confirmPassword"
					error-behavior="value"
					label="Пароль еще раз"
					placeholder="Введите значение"
					validation="bail|required|confirm:password"
					:validation-messages="{
						'required': 'укажите значение',
						'confirm': 'пароли не совпадают',
					}"
					validation-name="Confirm Password"
					class="col-8"
				/>
				<div class="col-8 mb-4">
					<FormulateInput
						v-model="agreements.personal_data"
						class="mb-3 small"
						type="checkbox"
						validation="required"
						name="personalData"
						:validation-messages="{
							required: $t('agreementRequired')
						}"
						data-action="personalData"
					>
						<template #label="{ id }">
							<label :for="id" class="ml-2">
								Даю
								<a
									:href="`https://www.skolkovo.ru/static/personaldata_rus.html`"
									target="_blank"
								>
									согласие на обработку персональных данных
								</a>
							</label>
						</template>
					</FormulateInput>
				</div>
				<div class="col-12 d-flex flex-column justify-content-end align-items-center mb-4">
					<span v-if="loginError" class="text-danger mb-2">{{ loginError }}</span>
					<FormulateInput
						type="submit"
						class="submit w-100"
					>
						{{ STEPS.AUTH_PASSWORD.buttonText }}
					</FormulateInput>
				</div>
				<div class="col-12 d-flex justify-content-center">
					<b-button
						variant="link"
						class="p-0"
						@click="setCurrentStep(STEPS.PHONE_CODE.name)"
					>
						Вернуться назад
					</b-button>
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import paymentFormMixin from '~/mixins/paymentFormMixin';
import agreementsMixin from '~/mixins/agreementsMixin';
import { mapGetters, mapMutations, mapState } from 'vuex';

const STEPS = {
	EMAIL: {
		name: 'email',
		buttonText: 'Продолжить',
	},
	EMAIL_CODE: {
		name: 'emailCode',
	},
	EMAIL_PASSWORD: {
		name: 'emailPassword',
		buttonText: 'Продолжить',
	},
	PHONE: {
		name: 'phone',
		buttonText: 'Получить код',
	},
	PHONE_CODE: {
		name: 'phoneCode',
	},
	AUTH_PASSWORD: {
		name: 'authPassword',
		buttonText: 'Зарегистрироваться и продолжить',
	},
};

const TIMER = 60;
const ONE_SECOND = 1000;

export default {
	name: 'AuthStep',
	components: {
	},
	mixins: [paymentFormMixin, agreementsMixin],
	props: {
		block: { type: Object, required: true },
		order: { type: Object, default: () => ({}) },
	},
	data() {
		return {
			STEPS,
			currentStep: STEPS.EMAIL.name,
			user: {
				registered: false,
				phoneVerified: false,
			},
			email: {
				value: null,
				code: null,
				password: null,
				isCodeValid: false,
				timeout: 0,
				error: '',
			},
			phone: {
				value: null,
				code: null,
				isCodeValid: false,
				isPhoneValid: false,
				timeout: 0,
				error: '',
			},
			loginError: '',
			last_name: null,
			first_name: null,
			middle_name: null,
			password: null,
			passwordConfirm: null,
			currentLoginType: 'email',
		};
	},
	computed: {
		...mapState('scenarios/paymentForm', ['isLoading']),
		...mapGetters('scenarios/paymentForm', ['payerType', 'isIpPayer', 'isPhysicalPayer']),
		agreementsDocs() {
			const product = this.order?.data?.products[0];
			return product?.agreements;
		},
		isFullUser() {
			const { registered, phoneVerified } = this.user;
			return registered && phoneVerified;
		},
	},
	methods: {
		...mapMutations('scenarios/paymentForm', ['setForm', 'setPayerType', 'setStep']),
		formatTime(ms) {
			const totalSeconds = Math.floor(ms / ONE_SECOND);

			// Вычисляем минуты и секунды
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;

			// Форматируем с добавлением ведущих нулей
			const formattedMinutes = String(minutes).padStart(2, '0');
			const formattedSeconds = String(seconds).padStart(2, '0');

			return `${formattedMinutes}:${formattedSeconds}`;
		},
		setCurrentStep(step) {
			this.email.error = '';
			this.phone.error = '';
			this.currentStep = step;
		},
		isCurrentStep(step) {
			return this.currentStep === step;
		},
		startTimer(slug) {
			this[slug].timeout = TIMER * ONE_SECOND;
			this[slug].timer = setInterval(() => {
				if (this[slug].timeout > 0) {
					this[slug].timeout -= ONE_SECOND;
				} else {
					clearInterval(this[slug].timer);
				}
			}, ONE_SECOND);
		},
		async checkUserEmail() {
			this.email.error = '';
			try {
				const {
					data: {
						registered,
						phone_verified: phoneVerified,
					},
				} = await this.$api.checkUserByEmailSkolkovoID(this.email.value);
				this.user = { registered, phoneVerified };
			} catch (e) {
				console.error(e);

				const { message } = e.response?.data;
				if (message) this.email.error = message;
			}
		},
		async sendEmailCode({ resend = false }) {
			await this.checkUserEmail();
			this.email.error = '';

			try {
				if (this.user.registered) {
					await this.$api.codeGenerate({ email: this.email.value });
				} else {
					await this.$api.sendEmailRegisterScenarioSkolkovoId(this.email.value);
				}
				if (!resend) this.setCurrentStep(STEPS.EMAIL_CODE.name);
				this.startTimer('email');
			} catch (e) {
				console.error(e);

				const { message } = e.response?.data;
				if (message) this.email.error = message;
			}
		},
		async sendPhoneCode({ resend = false }) {
			this.phone.error = '';
			try {
				const { value: phone } = this.phone;
				const { value: email, code } = this.email;
				await this.$api.sendPhoneRegisterScenarioSkolkovoId({ phone, email, email_code: code });
				if (!resend) this.setCurrentStep(STEPS.PHONE_CODE.name);
				this.startTimer('phone');
			} catch (e) {
				console.error(e);

				const { message } = e.response?.data;
				if (message) this.phone.error = message;
			}
		},
		async submitEmailCode() {
			if (this.user.registered) {
				await this.loginCode();
				return;
			}
			await this.verifyEmailCode();
		},
		async submitPhoneCode() {
			if (this.user.registered) {
				await this.loginUser();
				return;
			}
			await this.verifyPhoneCode();
		},
		async verifyEmailCode() {
			try {
				const { value: email, code } = this.email;
				await this.$api.verifyEmailRegisterScenarioSkolkovoId({ email, code });

				this.email.isCodeValid = true;
				this.$formulate.submit(STEPS.EMAIL_CODE.name);
				this.setCurrentStep(STEPS.PHONE.name);
			} catch (e) {
				console.error(e);
				this.email.isCodeValid = false;
				this.$formulate.submit(STEPS.EMAIL_CODE.name);
			}
		},
		async verifyPhoneCode() {
			try {
				const { value: phone, code } = this.phone;
				const { data: { message } } = await this.$api.verifyPhoneRegisterScenarioSkolkovoId({ phone, code });

				this.phone.isCodeValid = message;
				if (message) this.setCurrentStep(STEPS.AUTH_PASSWORD.name);
				this.$formulate.submit(STEPS.PHONE_CODE.name);
			} catch (e) {
				console.error(e);
				this.email.isCodeValid = false;
				this.$formulate.submit(STEPS.PHONE_CODE.name);
			}
		},
		async loginCode() {
			try {
				const { value: email, code } = this.email;

				await this.$auth.loginWith('code', {
					data: { email, code },
				});
				this.setStep(this.STEPS.INFO);
			} catch (e) {
				console.error(e);

				const { message } = e.response?.data;
				if (message) this.email.error = message;
			}
		},
		async loginEmail() {
			try {
				const { value: email, password } = this.email;

				await this.$auth.loginWith('local', {
					data: { email, password },
				}, { scenario: true });
				this.setStep(this.STEPS.INFO);
			} catch (e) {
				console.error(e);

				const { message } = e.response?.data;
				if (message) this.email.error = message;
			}
		},
		async loginUser() {
			this.loginError = '';
			try {
				await this.$auth.loginWith('scenario', {
					data: {
						phone: this.phone.value,
						code: this.phone.code,
					},
				});
				this.setStep(this.STEPS.INFO);
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.loginError = message;
				} catch {
					console.error(error);
					this.loginError = 'Что-то пошло не так';
				}
			}
		},
		async registerUser() {
			if (!this.phone.code) {
				await this.registerUserEmail();
				return;
			}

			await this.registerUserPhone();
		},
		async registerUserPhone() {
			this.loginError = '';
			try {
				await this.$auth.loginWith('scenario_register_phone', {
					data: {
						phone: this.phone.value,
						code: this.phone.code,
						password: this.password,
						password_confirmation: this.passwordConfirm,
						last_name: this.last_name,
						first_name: this.first_name,
						middle_name: this.middle_name,
					},
				});
				await this.setAgreementFields({ personalData: true }); // Agreement mixin
				this.setStep(this.STEPS.INFO);
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.loginError = message;
				} catch {
					console.error(error);
					this.loginError = 'Что-то пошло не так';
				}
			}
		},
		async registerUserEmail() {
			this.loginError = '';
			try {
				await this.$auth.loginWith('scenario_register_email', {
					data: {
						email: this.email.value,
						code: this.email.code,
						password: this.password,
						password_confirmation: this.passwordConfirm,
						last_name: this.last_name,
						first_name: this.first_name,
						middle_name: this.middle_name,
					},
				});
				await this.setAgreementFields({ personalData: true }); // Agreement mixin
				this.setStep(this.STEPS.INFO);
			} catch (error) {
				try {
					const {
						message,
					} = this.$api.getValidationFromError(error);
					this.loginError = message;
				} catch {
					console.error(error);
					this.loginError = 'Что-то пошло не так';
				}
			}
		},
		skipPhoneStep() {
			if (this.user.registered) {
				this.loginCode();
				return;
			}
			this.setCurrentStep(STEPS.AUTH_PASSWORD.name);
		},
		setLoginType(type) {
			this.currentLoginType = type;
		},
	},
};

</script>

<style lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

.login-tabs {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: .5rem;
	justify-content: space-between;
	background-color: $white;
	border-radius: 3rem;
	padding: 1px;
	border: 1px solid #ccc;

	&__button {
		flex: 1;
		color: $border-color;
		border-radius: 3rem;

		&.btn.btn-secondary {
			background-color: transparent;

			&.current {
				color: white;
				background-color: $blue;
				border-radius: 3rem;
			}

		}

		&:focus, &:active {
			//border: none;
			box-shadow: none;
			border-color: transparent;
		}

		:hover {
			border-color: $border-color;
		}
	}
	@include media-breakpoint-down(sm) {
		button {
			font-size: 0.8rem;
			font-weight: 500;
			padding: 0.375rem 0.45rem;
			border-radius: 3rem;
		}
	}

	.description {
		font-size: 1.2rem;
	}
}
</style>
